import icons from '../../img/icons.svg';
import View from './View.js';

class AddRecipeView extends View {
  _parentElement = document.querySelector('.upload');
  _openBtn = document.querySelector('.nav__btn--add-recipe');
  _closeBtn = document.querySelector('.btn--close-modal');
  _overlay = document.querySelector('.overlay');
  _window = document.querySelector('.add-recipe-window');
  _msg = 'Recipe succesfully uploaded!';

  constructor() {
    super();
    this._addHandlerOpenWindow();
    this._addHandlerCloseWindow();
  }

  addHandlerUpload(handler) {
    this._parentElement.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = [...new FormData(this)];
      const newRecipe = Object.fromEntries(formData);
      handler(newRecipe);
    });
  }

  toggleOverlay() {
    this._overlay.classList.toggle('hidden');
    this._window.classList.toggle('hidden');
  }

  _addHandlerCloseWindow() {
    this._closeBtn.addEventListener('click', this.toggleOverlay.bind(this));
  }

  _addHandlerOpenWindow() {
    this._openBtn.addEventListener('click', this.toggleOverlay.bind(this));
  }
}

export default new AddRecipeView();
